import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';
import { apiLucree, apiPlanos } from '../services/api';

export const PlanosContext = createContext([]);

export function PlanosProvider(props) {
	const { children, user } = props;
	const [maxParcelas, setMaxParcelas] =useState(0) ;

	async function authToken() {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}

	async function getMaxParcelasByUser(tokenData) {
		try {
			await apiPlanos.get(`maximo-parcela-plano/${user?.dados?.plano_id}/`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `${tokenData}`,

					},
				}).then((res) => {
					if(res.data.maximoParcelas){
						setMaxParcelas(res.data.maximoParcelas)
					}
				})
		} catch (error) {
			toast.error(
				'Nenhuma Liquidação encontrada.'
			);
		}
		return null;
	}

	return (
		<PlanosContext.Provider
			value={{
				authToken,
				maxParcelas,
				getMaxParcelasByUser,
			}}>
			{children}
		</PlanosContext.Provider>
	);
}
